import cn from 'classnames';
import { PropsWithChildren } from 'react';

import styles from './Table.module.scss';

type Props = {
  className?: string;
};

export const Table = ({ className, children }: PropsWithChildren<Props>) => (
  <div className={styles.container}>
    <table className={cn(styles.table, className)}>{children}</table>
  </div>
);
